import {
  addDays,
  format,
  isBefore,
  isSameDay,
  isSameYear,
  isValid,
  startOfWeek,
} from "date-fns";

const isOnOrAfter = (date: Date, boundary: Date) => !isBefore(date, boundary);

export const formatDocumentTableDate = (
  value?: Date | string,
  now = new Date()
) => {
  if (!value) return "";

  const date = new Date(value);

  if (!isValid(date)) return "";

  const startOfCurrentWeek = startOfWeek(now, { weekStartsOn: 0 });
  const startOfNextWeek = addDays(startOfCurrentWeek, 7);

  if (isSameDay(date, now)) {
    return `today, ${format(date, "HH:mm")}`;
  }

  if (
    isOnOrAfter(date, startOfCurrentWeek) &&
    isBefore(date, startOfNextWeek)
  ) {
    return format(date, "EEE, HH:mm");
  }

  if (!isSameYear(date, now)) {
    return format(date, "yyyy-MM-dd");
  }

  return format(date, "MMM d");
};
